module.exports = __webpack_public_path__ + "static/media/loop.c52a92f7.svg";